/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of files (patients) to display or load files */


(function () {
  'use strict';
  angular.module('vcdms.vcfile')
    .component('filelist', {
      restrict: 'E',
      bindings: {
        files: '<?',
        fidname: '@?',
        fid: '<?'
      },
      template: `
        <table class="table table-striped hidden-xs hidden-sm">
          <thead>
          <tr>
            <th>Datum</th>
            <th>Bezeichnung</th>
            <th>Tags</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="file in vm.files">
          <td>{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</td>
            <td>
                <span ng-show="file.filename" uib-tooltip="{{file.filename}}">{{file.type}}</span>
                <span ng-hide="file.filename">{{file.type}}</span>
            </td>
            <td>
              <span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}</span>
            </td>
            <td>
             <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">
                <i class="fa fa-eye"></i>
             </a>
             <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">
                <i class="fa fa-download"></i>
             </a>
             <!-- delete file, mit Rückfrage -->
             <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"
                ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">
                <i class="fa fa-remove"></i>
             </a>
             <!-- unlink file, mit Rückfrage -->
             <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"
               ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"
               class="btn btn-warning btn-xs">
                <i class="fa fa-unlink"></i>
             </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>
            </td>
          </tr>
        </table>
        <div class="hidden-md hidden-lg hidden-xl">
          <div class="row" ng-repeat="file in vm.files">
            <div class="col-xs-6">{{file.type}}</div>
            <div class="col-xs-6">{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</div>
            <!-- Note! <wbr> is needed to allow linebreaking of tag array -->
            <div class="col-xs-12"><span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}<wbr></span></div>
            <div class="col-xs-12">
               <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">
                  <i class="fa fa-eye"></i>
               </a>
               <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">
                  <i class="fa fa-download"></i>
               </a>
               <!-- delete file, mit Rückfrage -->
               <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"
                  ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">
                  <i class="fa fa-remove"></i>
               </a>
               <!-- unlink file, mit Rückfrage -->
               <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"
                 ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"
                 class="btn btn-warning btn-xs">
                  <i class="fa fa-unlink"></i>
               </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>
            </div>
          </div>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'File', 'FileHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, File, FileHelper, vertxEventBusService) {
          let vm = this;
          vm.editFile = FileHelper.editFile;
          vm.removeFile = removeFile;
          vm.getTags = getTags;

          vm.$onInit = function () {
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.files)) {
              if (angular.isDefined(vm.fid) && angular.isDefined(vm.fidname)) {
                File.$searchBy(vm.fidname, vm.fid).$then(function (files) {
                  vm.files = files;
                }, function (err) {
                  $log.error('files search by foreign id failed, id: ', vm.fidname, vm.fid, err);
                  Rlog.error('files', 'filelist', 'files search by foreign id failed ', {
                    fid: vm.fid,
                    fidname: vm.fidname
                  });
                });
              }
            }
          }; // $onInit()

          // vm.consultid might be late propagating, get consult on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.fid)) {
                vm.fid = changes.fid.currentValue;
                File.$searchBy(vm.fidname, vm.fid).$then(function (files) {
                  vm.files = files;
                }, function (err) {
                  $log.error('files search by foreign id failed, id: ', vm.fidname, vm.fid, err);
                  Rlog.error('files', 'filelist', 'files search by foreign id failed ', {
                    fid: vm.fid,
                    fidname: vm.fidname
                  });
                });
              }
            }
          };

          function removeFile(file) {
            file.active = false;
            file.$save();
          }

          function getTags(val) {
            $log.debug('debug - getTags called!');
            let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];

            return $http.post('/routes/files/aggregate', match).then(function (response) {
              let tags = [];
              // $log.debug('tags data received: ', response);
              for (let i = 0; i < response.data.length; i++) {
                tags.push({text: response.data[i]._id});
              }
              $log.debug('debug - tags: ', tags);
              return tags;
            });
          }

          const filesUpdateHandler = function (message) {
            $log.debug('debug: file update received: ', message);
            if (angular.isDefined(vm.files)) {
              vm.files.$refresh().$then(function () {
                $log.debug('debug: filelist refreshed files');
              }, function (error) {
                $log.debug('debug: filelist refresh files failed: ', error);
              });
            }
          };

          vertxEventBusService.on('files.update', {}, filesUpdateHandler);


          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
          };


          vm.helpunlink = `Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die 
            Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. 
            W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.`;

        }] // controller
    }); // component

  // klammerfriedhof
}());
